import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';

import { CurtainHeader } from 'curtain/components/CurtainHeader';

import { clearCurtain } from 'curtain/store/curtainActions';

import { lynch } from 'shared/config/Colors';

import SVG from 'shared/components/SVG';
import ScrollbarsCustom from 'shared/components/ScrollbarsCustom';
import { ButtonIcon } from 'shared/components/Button';
import { H3, P } from 'shared/components/Typography';
import { Spacer } from 'shared/components/Layout';
import { Wrapper } from 'shared/components/Wrapper';
import { useAppDispatch } from 'shared/hooks/useAppDispatch';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { useEffect } from 'react';
import { getDealershipPreferences } from 'order/store/orderActions';
import { DealershipPreference } from 'order/components/DealershipPreferences/DealershipPreferences';

const TabContainer = styled(Wrapper)`
  // Total page height minus header and footer heights plus bottom-border height
  height: 100%;
  overflow: auto;
`;

export const DealershipPreferencesTab = () => {
  const dispatch = useAppDispatch();

  const order = useSelector((state: RootState) => state.orderReducer.order);

  const dealershipPreferences = useSelector(
    (state: RootState) => state.orderReducer.dealershipPreferences
  );

  useEffect(() => {
    if (order) {
      dispatch(
        getDealershipPreferences({
          dealershipId: order.dealershipId!,
        })
      );
    }
  }, [order]);

  return (
    <Wrapper style={{ height: '100%' }}>
      <TabContainer>
        <ScrollbarsCustom
          autoHide={false}
          autoHideTimeout={500}
          autoHideDuration={300}
          paddingRight={0}
        >
          {/* Tab Heading */}
          <CurtainHeader flex middle between>
            <Wrapper flex gap={12}>
              <H3>Dealership Preferences</H3>
            </Wrapper>
            {/* Close Curtain Button */}
            <Wrapper flex middle>
              <ButtonIcon onClick={() => dispatch(clearCurtain())}>
                <SVG icon={<CloseIcon />} hoverColor={lynch} />
              </ButtonIcon>
            </Wrapper>
          </CurtainHeader>

          {/* Table */}
          <Wrapper maxWidth={600} style={{ padding: '16px 20px' }}>
            {!dealershipPreferences?.length && (
              <P>No Dealership preferences at this moment.</P>
            )}

            {dealershipPreferences?.map((dp) => (
              <DealershipPreference key={dp}>{dp}</DealershipPreference>
            ))}
          </Wrapper>

          {/* Footer Spacing */}
          <Spacer h="20px" />
        </ScrollbarsCustom>
      </TabContainer>
    </Wrapper>
  );
};
